import { render, staticRenderFns } from "./EditorControls.vue?vue&type=template&id=a5b9e68a"
import script from "./EditorControls.vue?vue&type=script&lang=js"
export * from "./EditorControls.vue?vue&type=script&lang=js"
import style0 from "./EditorControls.vue?vue&type=style&index=0&id=a5b9e68a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports